import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';

const Footer = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get('/settings/public').then(res => setSettings(res.data)).catch(() => {});
  }, []);

  const handle = settings?.instagramHandle || 'milkandhoneycoffeecart';

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>Milk & Honey Coffee Cart</h4>
          <p>
            A faith-based mobile coffee cart serving San Antonio, TX.
            We bring the coffee experience to your events with love and excellence.
          </p>
        </div>
        <div className="footer-section">
          <h4>Quick Links</h4>
          <p><Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Home</Link></p>
          <p><Link to="/menu" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Our Menu</Link></p>
          <p><Link to="/about" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>About Us</Link></p>
          <p><Link to="/quote" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Get a Free Quote</Link></p>
        </div>
        <div className="footer-section">
          <h4>Contact Us</h4>
          <p>{settings?.businessAddress || 'San Antonio, TX'}</p>
          {settings?.businessEmail && (
            <p><a href={`mailto:${settings.businessEmail}`}>{settings.businessEmail}</a></p>
          )}
          {settings?.businessPhone && (
            <p><a href={`tel:${settings.businessPhone}`}>{settings.businessPhone}</a></p>
          )}
          <p>
            <a href={`https://www.instagram.com/${handle}/`} target="_blank" rel="noopener noreferrer">
              @{handle}
            </a>
          </p>
        </div>
      </div>
      <div className="footer-bottom">
        <p className="footer-verse">
          "He brought us to this place and gave us this land flowing with milk & honey"
        </p>
        <p>Deuteronomy 26:9</p>
        <div style={{ marginTop: '1rem', fontSize: '0.8rem', opacity: 0.8 }}>
          &copy; {new Date().getFullYear()} Milk & Honey Coffee Cart. All rights reserved.
          <div style={{ marginTop: '0.5rem' }}>
            Website created by <a href="https://codingcarranza.com" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--gold-light)', textDecoration: 'underline' }}>Coding Carranza LLC</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
